const SUPPORTED_LANGUAGES = ['en', 'fr'];

export function filterLanguage(language: string): string {
  if (language) {
    const newLanguage = language.toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(newLanguage)) {
      return newLanguage;
    }
  }
  return null;
}
